import { render } from "./WorkflowList.vue?vue&type=template&id=20325ca7&scoped=true"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"

import "./WorkflowList.vue?vue&type=style&index=0&id=20325ca7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20325ca7"]])

export default __exports__